angular.module( 'acme.view.application.templates.create.schedules.create.resources', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.view.application.templates.create.schedules.create.resources.controllers',
  'acme.view.application.resources.requests.removeModal.controllers'
  ])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var templatesCreateSchedulesCreateResources = {
        name: 'application.templates.create.schedules.create.resources',
        url: '/resources',
        views: {
          "subview-main": {
            controller: 'TemplatesCreateSchedulesCreateResourcesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/templates/create/schedules/create/resources/resources.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Event Template Schedule Resources'
        },
        resolve: {
          selectizeCSS: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.loadCss( "/assets/selectize.bootstrap3.css", 'selectize-css', function() {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;
          }]
        }
      },
      templatesEditSchedulesCreateResources = {
          name: 'application.templates.edit.schedules.create.resources',
          url: '/resources',
          views: {
              "subview-main": {
                  controller: 'TemplatesCreateSchedulesCreateResourcesController',
                  // Assumes the view is entirely self contained
                  templateUrl: 'views/application/views/templates/create/schedules/create/resources/resources.tpl.html'
              }
          },
          data: {
              pageTitle: 'Edit Event Template Schedule Resources'
          },
          resolve: {
            selectizeCSS: ['$q', function($q) {
              var q = $q.defer();

              // Usage
              $.loadCss( "/assets/selectize.bootstrap3.css", 'selectize-css', function() {
                q.resolve('done');
              }, function() {
                q.resolve('fail');
              });

              return q.promise;
            }]
          }
      },
      templatesEditSchedulesEditResources = {
          name: 'application.templates.edit.schedules.edit.resources',
          url: '/resources',
          views: {
              "subview-main": {
                  controller: 'TemplatesCreateSchedulesCreateResourcesController',
                  // Assumes the view is entirely self contained
                  templateUrl: 'views/application/views/templates/create/schedules/create/resources/resources.tpl.html'
              }
          },
          data: {
              pageTitle: 'Edit Event Template Schedule Resources'
          },
          resolve: {
            selectizeCSS: ['$q', function($q) {
              var q = $q.defer();

              // Usage
              $.loadCss( "/assets/selectize.bootstrap3.css", 'selectize-css', function() {
                q.resolve('done');
              }, function() {
                q.resolve('fail');
              });

              return q.promise;
            }]
          }
      };

    $stateProvider
      .state(templatesCreateSchedulesCreateResources)
      .state(templatesEditSchedulesCreateResources)
      .state(templatesEditSchedulesEditResources);
});
